module.exports = __webpack_public_path__ + "img/Skirt-Front-B2-Db-Fc-Ga-Hc-Ia.ed1e4c34.png";